import { type Websocket } from 'entities/WebSocket'

interface IEventUserProps {
  id: number | string
}

export class ChannelUser {
  privateChannelName: string
  presenceChannelName: string

  constructor(props: IEventUserProps, private _websocket: Websocket) {
    this.privateChannelName = `private-user.${props.id}`
    this.presenceChannelName = `presence-user.${props.id}`

    this.subscribe()
  }

  subscribe() {
    this._websocket.subscribe(this.privateChannelName)
    this._websocket.subscribe(this.presenceChannelName)
  }
}
